type BeatCallback = (beatCount: number) => void;

/**
 * BeatSync: emits BEAT events at a configured BPM.
 * Pure logic, no Phaser dependency - driven by delta time from scene update.
 */
export class BeatSync {
  readonly beatIntervalMs: number;
  private accumulator = 0;
  private _beatCount = 0;
  private callbacks: Set<BeatCallback> = new Set();

  constructor(bpm: number) {
    this.beatIntervalMs = 60_000 / bpm;
  }

  get beatCount(): number {
    return this._beatCount;
  }

  /** Progress through the current beat interval, 0 to 1 */
  get beatProgress(): number {
    return this.accumulator / this.beatIntervalMs;
  }

  /** Register a callback to fire on each beat */
  onBeat(callback: BeatCallback): void {
    this.callbacks.add(callback);
  }

  /** Remove a beat callback */
  offBeat(callback: BeatCallback): void {
    this.callbacks.delete(callback);
  }

  /** Update with delta time in ms. Call from scene update(). */
  update(deltaMs: number): void {
    this.accumulator += deltaMs;

    while (this.accumulator >= this.beatIntervalMs) {
      this.accumulator -= this.beatIntervalMs;
      this._beatCount++;
      for (const cb of this.callbacks) {
        cb(this._beatCount);
      }
    }
  }
}
